/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".questionnaire-grade-score[_ngcontent-%COMP%]{\n  margin: 0 auto;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n\n.questionnaire-grade-score[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{\n  font-size: 0.6rem;\n  color: rgb(225,227,235);\n}\n\n.questionnaire-grade-score[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%]{\n  color: rgb(252,214,35);\n}\n\n.questionnaire-grade-score[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] + li[_ngcontent-%COMP%]{\n  margin-left: 0.2rem;\n}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/component/questionnire/child-grade/component.questionnaire-grade.css.shim.ngstyle.js.pre-build-optimizer.js